import { archiveProject, unarchiveProject } from '@lib/api'
import { adminProjectsKeys } from '@lib/keys'
import { useMutation, useQueryClient } from '@tanstack/react-query'

export const useArchiveProject = () => {
  const queryClient = useQueryClient()

  return useMutation((id: number) => archiveProject(id), {
    onSuccess: () => {
      void queryClient.invalidateQueries(adminProjectsKeys.all)
    },
  })
}

export const useUnarchiveProject = () => {
  const queryClient = useQueryClient()

  return useMutation((id: number) => unarchiveProject(id), {
    onSuccess: () => {
      void queryClient.invalidateQueries(adminProjectsKeys.all)
    },
  })
}
